import React, { useEffect, useMemo, useRef, useState } from "react";
import "./SucessOrder.css";
import { useLocation, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useCart } from "../CartProvider";
import emailjs from "@emailjs/browser";
import { useLogin } from "../LoginProvider";

// Helpers
const formatMoneySod = (n) => Number(n || 0).toLocaleString("fr-FR");

const safeTextSod = (v, fallback = "-") => {
  if (v === null || v === undefined) return fallback;
  const s = String(v).trim();
  return s.length ? s : fallback;
};

const sleepSod = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Champ Paid: accepte Paid:true, ou Etat:"paid"/"success"
const isPaidSod = (order) => {
  if (!order) return false;
  if (order.Paid === true) return true;

  const etat = String(order.Etat || "").toLowerCase();
  const cashpayState = String(
    order.cashpay_payment_state || order?.PaymentData?.state || ""
  ).toLowerCase();

  return (
    etat === "paid" ||
    etat === "success" ||
    etat === "succeeded" ||
    cashpayState === "paid" ||
    cashpayState === "success" ||
    cashpayState === "completed"
  );
};

export default function SucessOrder() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useLogin();
  const { clear } = useCart();

  const clearedOnceRef = useRef(false);
  const notifiedOnceRef = useRef(false);
  const callbackTriggeredRef = useRef(false);

  const [loadingSod, setLoadingSod] = useState(true);
  const [errorSod, setErrorSod] = useState("");
  const [ordersSod, setOrdersSod] = useState([]);

  useEffect(() => {
    document.title = "Merci pour votre commande - dollarstoretogo.com";
  }, []);

  const searchParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  // Supporte :
  // 1) location.state.orderIds
  // 2) ?ids=id1,id2
  // 3) ?orderId=id1
  const orderIds = useMemo(() => {
    const fromState = location?.state?.orderIds;
    if (Array.isArray(fromState) && fromState.length) {
      return fromState.map(String).map((x) => x.trim()).filter(Boolean);
    }

    const ids = searchParams.get("ids");
    if (ids) {
      return ids
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean);
    }

    const orderId = searchParams.get("orderId");
    if (orderId) {
      return [orderId.trim()].filter(Boolean);
    }

    return [];
  }, [location.state, searchParams]);

  // Paramètres callback / paiement
  const callbackParams = useMemo(() => {
    const obj = {
      reference: searchParams.get("reference") || "",
      merchant_reference: searchParams.get("merchant_reference") || "",
      order_reference: searchParams.get("order_reference") || "",
      orderId: searchParams.get("orderId") || "",
      code: searchParams.get("code") || "",
      status: searchParams.get("status") || "success",
      state: searchParams.get("state") || "PAID",
      amount: searchParams.get("amount") || "",
      currency: searchParams.get("currency") || "XOF",
    };

    return obj;
  }, [searchParams]);

  useEffect(() => {
    if (!orderIds.length) {
      navigate("/", { replace: true });
    }
  }, [orderIds, navigate]);

  useEffect(() => {
    let cancelled = false;

    const sendEmail = async (commande, items, currentUser) => {
      try {
        const safeItems = Array.isArray(items) ? items : [];
        let grandTotal = 0;

        const rows = safeItems
          .map((it) => {
            const q = Number(it.qty ?? 0);
            const price = Number(it.price ?? 0);
            const base = q * price;

            const userHasDiscount = Number(currentUser?.discount ?? 0) > 0;
            const eligible = Boolean(it.getDiscount);
            const percent = Number(it.maxiDiscount ?? 0);

            const lineTotal =
              userHasDiscount && eligible && percent > 0
                ? base * (1 - percent / 100)
                : base;

            grandTotal += lineTotal;

            const img = it.image || "";
            const title = String(it.title || "Produit").slice(0, 60);

            return `
              <tr>
                <td>
                  ${
                    img
                      ? `<img src="${img}" alt="${title}" width="50" height="50" style="object-fit:cover; border-radius:6px; margin-right:8px;" />`
                      : ""
                  }
                  ${title}
                </td>
                <td style="text-align:center;">${q}</td>
                <td style="text-align:right;">${price} FCFA</td>
                <td style="text-align:right;">${Math.round(lineTotal)} FCFA</td>
              </tr>
            `;
          })
          .join("");

        const templateParams = {
          name: currentUser?.name || "Client",
          user_email: "dagbajean50@gmail.com",
          VName: "Dollar Store",
          from_email: "dollarstoretogo@gmail.com",
          reply_to: "dollarstoretogo@gmail.com",
          subject: `Commande: #${commande}`,
          notes: `
            <p>Nouvelle commande sur Dollar Store :</p>

            <table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse;width:100%;font-family:sans-serif;font-size:14px;">
              <thead style="background:#f0f0f0;">
                <tr>
                  <th align="left">Produit</th>
                  <th align="center">Qté</th>
                  <th align="right">Prix</th>
                  <th align="right">Total</th>
                </tr>
              </thead>
              <tbody>
                ${rows}
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" align="right"><strong>Total global :</strong></td>
                  <td align="right"><strong>${Math.round(grandTotal)} FCFA</strong></td>
                </tr>
              </tfoot>
            </table>
          `,
        };

        if (!/\S+@\S+\.\S+/.test(templateParams.user_email)) return;

        await emailjs.send(
          "service_iwp21zr",
          "template_qllf7xk",
          templateParams,
          "wMCBY4g_tRljJp2SS"
        );
      } catch (err) {
        console.error("❌ Erreur email:", err?.text || err);
      }
    };

    const sendWhatsapp = async ({ invoiceCode, realTotal, currentUser, phones }) => {
      try {
        const dates = new Date().toLocaleDateString("fr-FR");
        const name = currentUser?.name || "Client";
        const phone = currentUser?.phone || phones || "-";

        const message = `*Nouvelle commande !*
${name} - ${phone} vient de passer une commande : *${invoiceCode}*
Total : *${realTotal} FCFA*
Date : ${dates}
Type: Livraison`;

        const res = await fetch("https://www.dollarstoretogo.com/api/send-whatsapp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ to: "+22870030389", text: message }),
        });

        const text = await res.text();
        let data = null;

        try {
          data = JSON.parse(text);
        } catch {
          data = { raw: text };
        }

        if (!res.ok) return;
      } catch (err) {
        console.error("❌ Erreur envoi WhatsApp :", err);
      }
    };

    const triggerCashpayCallback = async () => {
      if (callbackTriggeredRef.current) return;
      callbackTriggeredRef.current = true;

      try {
        const firstOrderId = orderIds[0] || callbackParams.orderId || "";
        const payload = new URLSearchParams();

        if (callbackParams.reference) payload.set("reference", callbackParams.reference);
        if (callbackParams.merchant_reference) {
          payload.set("merchant_reference", callbackParams.merchant_reference);
        }
        if (callbackParams.order_reference) {
          payload.set("order_reference", callbackParams.order_reference);
        }
        if (callbackParams.orderId || firstOrderId) {
          payload.set("orderId", callbackParams.orderId || firstOrderId);
        }
        if (callbackParams.code) payload.set("code", callbackParams.code);
        if (callbackParams.status) payload.set("status", callbackParams.status);
        if (callbackParams.state) payload.set("state", callbackParams.state);
        if (callbackParams.amount) payload.set("amount", callbackParams.amount);
        if (callbackParams.currency) payload.set("currency", callbackParams.currency);

        const url = `/api/cashpay-callback?${payload.toString()}`;

        console.log("🔁 Appel auto callback CashPay:", url);

        const res = await fetch(url, { method: "GET" });
        const text = await res.text();

        try {
          console.log("✅ Réponse callback:", JSON.parse(text));
        } catch {
          console.log("✅ Réponse callback brute:", text);
        }
      } catch (err) {
        console.error("❌ Erreur callback auto:", err);
      }
    };

    const loadOrders = async () => {
      const docs = await Promise.all(
        orderIds.map(async (id) => {
          const ref = doc(db, "ecom_orders", id);
          const snap = await getDoc(ref);

          if (!snap.exists()) return null;
          return { id: snap.id, ...snap.data() };
        })
      );

      return docs.filter(Boolean);
    };

    const run = async () => {
      try {
        setLoadingSod(true);
        setErrorSod("");

        if (!orderIds.length) {
          setLoadingSod(false);
          return;
        }

        // 1) premier chargement
        let clean = await loadOrders();

        if (cancelled) return;

        if (clean.length !== orderIds.length) {
          navigate("/", { replace: true });
          return;
        }

        // 2) si pas encore payé, on déclenche le callback auto
        if (clean.some((o) => !isPaidSod(o))) {
          await triggerCashpayCallback();

          // petit délai pour laisser Firestore se mettre à jour
          await sleepSod(1500);

          // 3) on relit les commandes
          clean = await loadOrders();

          if (cancelled) return;
        }

        // 4) si toujours pas payé, on n'envoie plus vers cart tout de suite
        // on laisse une erreur claire à l'écran
        if (clean.some((o) => !isPaidSod(o))) {
          setErrorSod(
            "Le paiement est en cours de confirmation. Rechargez la page dans quelques secondes."
          );
          setLoadingSod(false);
          return;
        }

        setOrdersSod(clean);

        if (!clearedOnceRef.current) {
          clearedOnceRef.current = true;
          clear();
        }

        if (!notifiedOnceRef.current) {
          notifiedOnceRef.current = true;

          const first = clean[0];
          if (first) {
            const invoiceCode = first.invoiceCode || first.code || first.id;
            const realTotal = first.AfterTotal || first.TotalPrice || 0;

            await Promise.allSettled([
              sendEmail(invoiceCode, first.OrdersItems || [], user),
              // sendWhatsapp({
              //   invoiceCode,
              //   realTotal,
              //   currentUser: user,
              //   phones: first.Telephone,
              // }),
            ]);
          }
        }
      } catch (e) {
        console.error(e);
        if (!cancelled) {
          setErrorSod("Impossible de récupérer la commande.");
        }
      } finally {
        if (!cancelled) {
          setLoadingSod(false);
        }
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [orderIds, navigate, clear, user, callbackParams]);

  const firstOrderSod = ordersSod[0] || null;

  const allItemsSod = useMemo(() => {
    const items = [];
    for (const o of ordersSod) {
      const arr = Array.isArray(o.OrdersItems) ? o.OrdersItems : [];
      for (const it of arr) {
        items.push({ ...it, __orderId: o.id });
      }
    }
    return items;
  }, [ordersSod]);

  const subtotalSod = useMemo(() => {
    if (firstOrderSod?.TotalPrice) {
      return Number(firstOrderSod.TotalPrice || 0);
    }

    return allItemsSod.reduce((s, it) => {
      return s + Number(it?.price || 0) * Number(it.qty || 0);
    }, 0);
  }, [firstOrderSod, allItemsSod]);

  const deliveryFeeSod = Number(firstOrderSod?.DeliveryFee || 0);
  const taxeSod = Number(firstOrderSod?.TaxeFee || 0);
  const afterTotalSod = Number(
    firstOrderSod?.AfterTotal || subtotalSod + deliveryFeeSod + taxeSod
  );

  const paymentMethodRawSod =
    firstOrderSod?.PaymentMethod ||
    firstOrderSod?.channels ||
    firstOrderSod?.Channel ||
    "—";

  const paymentMethodLabelSod =
    paymentMethodRawSod === "CREDIT_CARD"
      ? "Carte bancaire"
      : paymentMethodRawSod === "MOBILE_MONEY"
      ? "Mobile Money"
      : String(paymentMethodRawSod);

  if (loadingSod) {
    return (
      <div className="sod-page-sod">
        <div className="sod-container-sod">
          <div className="sod-card-sod">
            <div className="sod-skeleton-line-sod" />
            <div className="sod-skeleton-line-sod" />
            <div className="sod-skeleton-line-sod" />
          </div>
        </div>
      </div>
    );
  }

  if (errorSod) {
    return (
      <div className="sod-page-sod">
        <div className="sod-container-sod">
          <div className="sod-alert-sod">{errorSod}</div>
        </div>
      </div>
    );
  }

  if (!ordersSod.length) {
    return (
      <div className="sod-page-sod">
        <div className="sod-container-sod">
          <div className="sod-alert-sod">Redirection...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="sod-page-sod">
      <div className="sod-topbar-sod">
        <div className="sod-container-sod sod-topbar-inner-sod">
          <div className="sod-brand-sod">
            <div className="sod-logo-sod">
              <img
                src="/images/dollarstore.jpg"
                style={{ width: 50, height: 50 }}
                alt="Dollar Store"
              />
            </div>
            <div className="sod-brand-text-sod" />
          </div>

          
        </div>
      </div>

      <div className="sod-container-sod">
        <div
          className="sod-hero-sod"
          style={{
            textAlign: "center",
            padding: "40px 20px",
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
            maxWidth: 700,
            margin: "0 auto",
          }}
        >
          <img
            src="/images/sucess.gif"
            alt="Commande réussie"
            style={{
              width: "100%",
              maxWidth: 280,
              height: "auto",
              marginBottom: 20,
            }}
          />

          <h1
            className="sod-title-sod"
            style={{
              fontSize: 28,
              fontWeight: 700,
              color: "#1a1a1a",
              marginBottom: 10,
            }}
          >
            Merci pour votre commande 🎉
          </h1>

          <div
            className="sod-subtitle-sod"
            style={{
              fontSize: 18,
              color: "#2e7d32",
              fontWeight: 600,
              marginBottom: 10,
            }}
          >
            Votre commande a été enregistrée et payée avec succès.
          </div>

          <div
            className="sod-note-sod"
            style={{
              fontSize: 15,
              color: "#555",
              lineHeight: 1.6,
              marginTop: 10,
            }}
          >
            Notre équipe vous contactera très prochainement pour la confirmation
            et la livraison.
          </div>

          <div
            style={{
              marginTop: 20,
              padding: "14px 18px",
              background: "#f5f7ff",
              borderRadius: 10,
              border: "1px solid #e2e6ff",
              fontSize: 15,
              color: "#333",
            }}
          >
            <strong>Besoin d’un traitement d'urgence ?</strong>
            <br />
            Vous pouvez envoyer une capture de votre commande via WhatsApp au
            <div
              style={{
                marginTop: 8,
                fontSize: 18,
                fontWeight: 700,
                color: "#0b5ed7",
              }}
            >
              +228 90 04 59 26
            </div>
          </div>
        </div>

        <div className="sod-card-sod">
          <div className="sod-card-title-sod">Détails de la commande</div>

          <div className="sod-order-grid-sod">
            <div className="sod-order-row-sod">
              <div className="sod-label-sod">Numéro de commande :</div>
              <div className="sod-value-sod">
                {safeTextSod(
                  firstOrderSod?.invoiceCode || firstOrderSod?.code || firstOrderSod?.id
                )}
              </div>
            </div>

            <div className="sod-order-row-sod">
              <div className="sod-label-sod">ID technique :</div>
              <div className="sod-value-sod">{safeTextSod(firstOrderSod?.id)}</div>
            </div>

            <div className="sod-order-row-sod">
              <div className="sod-label-sod">Date :</div>
              <div className="sod-value-sod">
                {firstOrderSod?.createdAt?.toDate
                  ? firstOrderSod.createdAt.toDate().toLocaleDateString("fr-FR", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })
                  : safeTextSod(firstOrderSod?.createdAt)}
              </div>
            </div>

            <div className="sod-order-row-sod">
              <div className="sod-label-sod">Méthode de paiement :</div>
              <div className="sod-value-sod">
                {safeTextSod(paymentMethodLabelSod)}
              </div>
            </div>

            <div className="sod-summary-sod">
              <div className="sod-summary-line-sod">
                <span className="sod-summary-label-sod">Sous-total :</span>
                <span className="sod-summary-val-sod">
                  {formatMoneySod(subtotalSod)} FCFA
                </span>
              </div>

              <div className="sod-summary-line-sod">
                <span className="sod-summary-label-sod">Livraison :</span>
                <span className="sod-summary-val-sod">
                  {formatMoneySod(deliveryFeeSod)} FCFA
                </span>
              </div>

              <div className="sod-summary-line-sod">
                <span className="sod-summary-label-sod">Taxe :</span>
                <span className="sod-summary-val-sod">
                  {formatMoneySod(taxeSod)} FCFA
                </span>
              </div>

              <div className="sod-summary-line-sod sod-summary-total-sod">
                <span className="sod-summary-label-sod">Total :</span>
                <span className="sod-summary-val-sod">
                  {formatMoneySod(afterTotalSod)} FCFA
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="sod-footer-sod">
          © {new Date().getFullYear()} Dollar Store TOGO
        </div>
      </div>
    </div>
  );
}